import gql from 'graphql-tag';

export default gql`
  mutation modifyAccountStatus($status: String!, $accountId: Int!) {
    modifyAccountStatus(status: $status, accountId: $accountId) {
      id
    }
  }
`;
